import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { Box, CircularProgress, Alert } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { getCollaborationWorkspace } from '../../api/backendApi';
import CollaborationWorkspaceContent from '../../components/collaboration/CollaborationWorkspaceContent';
import MainLayout from '../../components/layout/MainLayout';

const CollaborationWorkspacePage = () => {
  const { workspaceId } = useParams();
  const { tenantId, userData } = useAuth();
  const resolvedTenantId = tenantId || userData?.tenantId;

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [workspace, setWorkspace] = useState(null);

  useEffect(() => {
    if (!resolvedTenantId || !workspaceId) {
      setError('Missing tenant or workspace ID');
      setLoading(false);
      return;
    }

    let active = true;
    const load = async () => {
      try {
        const ws = await getCollaborationWorkspace(resolvedTenantId, workspaceId);
        if (!active) return;

        if (!ws) {
          setError('Collaboration workspace not found');
          return;
        }

        setWorkspace(ws);
      } catch (e) {
        if (!active) return;
        setError(e.message || 'Failed to load collaboration workspace');
      } finally {
        if (active) setLoading(false);
      }
    };

    load();
    return () => { active = false; };
  }, [resolvedTenantId, workspaceId]);

  return (
    <MainLayout>
      <Box sx={{ p: 3, maxWidth: 1100, mx: 'auto' }}>
        {loading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', pt: 6 }}>
            <CircularProgress />
          </Box>
        )}
        {!loading && error && (
          <Alert severity="error">{error}</Alert>
        )}
        {!loading && !error && workspace && (
          <CollaborationWorkspaceContent
            workspace={workspace}
            workspaceName={workspace.name}
          />
        )}
      </Box>
    </MainLayout>
  );
};

export default CollaborationWorkspacePage;
